exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-sidebar {\r\n  z-index: 1;\r\n  position: absolute;\r\n  overflow-y: auto;\r\n  scrollbar-track-color: #000000;\r\n  scrollbar-face-color: #6a6a6a;\r\n}\r\n\r\n.wrapper-main-content {\r\n  width: 100%;\r\n  position: absolute;\r\n  padding-top: 10px;\r\n  padding-bottom: 150px;\r\n}\r\n\r\n.wrapper-taskbar {\r\n  z-index: 1;\r\n  position: absolute;\r\n  overflow-y: auto;\r\n}\r\n\r\n.tbar-hide-main {\r\n  overflow-y: unset;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/content-page.component.css
// module id = ../../../../../src/app/content-page/content-page.component.css
// module chunks = main